import { render, staticRenderFns } from "./OdemeHatiratmaMaili.vue?vue&type=template&id=c4fcd206&"
import script from "./OdemeHatiratmaMaili.vue?vue&type=script&lang=js&"
export * from "./OdemeHatiratmaMaili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports